import React from 'react';
import { useHistory } from "react-router-dom";

const SearchButton = (props) => {
  const history = useHistory();

  const handleClick = () => {
    history.push("/search");
  };

  return (
    <div className="SearchDiv" style={{ cursor: 'pointer' }} onClick={handleClick}>
      <div style={{
        display: 'flex',
        alignItems: 'center',
        width: '100%',
        height: '100%',
        position: 'relative'
      }}>
        <input
          type="text"
          value=""
          placeholder={props.pHolder}
          readOnly
          style={{ cursor: 'pointer', caretColor: 'transparent' }}
        />
        <img 
          id="searchBtn" 
          src="/PermanentImages/searchIc.gif" 
          alt="" 
          style={{ pointerEvents: 'none' }}
        />
      </div>
    </div>
  );
};

export default SearchButton;
